import {
    DataGrid,
    GridCellEditCommitParams,
    GridColDef,
    gridPageCountSelector,
    gridPageSelector,
    GridRowParams,
    GridToolbarContainer,
    useGridApiContext,
    useGridSelector,
  } from '@mui/x-data-grid'
  import {Box, Button, Pagination, styled, Theme} from '@mui/material'
  import {useEffect, useState} from 'react'
  import {useDispatch} from 'react-redux'
  
  type Props = {
    rowData: any
    column: any
    handleClickRow: (param: any) => void
    handleDoubleClickRow?: (param: any) => void
    pageSize: number
    currentPage?: number
    addableRow?: boolean
    hidePagination?: boolean
    showCheckBox?: boolean
    heightTable?: string
    loading?: boolean
    totalRows?: number
    handleOnChangePage?: (page: number) => void
    handleEditRow?: (data: any) => void
    handleGetSelectedRow?: (data: any) => void
  }
  
  function customCheckbox(theme: Theme) {
    return {
      '& .MuiCheckbox-root svg': {
        width: 16,
        height: 16,
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.mode === 'light' ? '#d9d9d9' : 'rgb(67, 67, 67)'}`,
        borderRadius: 2,
      },
      '& .MuiCheckbox-root svg path': {
        display: 'none',
      },
      '& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg': {
        backgroundColor: '#1f8ce9',
        borderColor: '#d9d9d9',
      },
      '& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after': {
        position: 'absolute',
        display: 'table',
        border: '2px solid #fff',
        borderTop: 0,
        borderLeft: 0,
        transform: 'rotate(45deg) translate(-50%,-50%)',
        opacity: 1,
        transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
        content: '""',
        top: '50%',
        left: '39%',
        width: 5.71428571,
        height: 9.14285714,
      },
      '& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after': {
        width: 8,
        height: 8,
        backgroundColor: '#1f8ce9',
        transform: 'none',
        top: '39%',
        border: 0,
      },
    }
  }
  
  const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    border: 0,
    color: theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    // '& .MuiDataGrid-columnsContainer': {
    //   backgroundColor: '#fafafa',
    // },
    '& .MuiDataGrid-main': {
      boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#F4F6F8',
      color: '#637381',
    //   fontSize: '11px',
      textAlign: 'center',
      textTransform: 'uppercase',
      minHeight: '48px !important',
      maxHeight: '48px !important',
    },
    '& .MuiDataGrid-columnHeadersInner': {
      transform: 'translate3d(0px, 0px, 0px)',
    },
    '& .MuiDataGrid-virtualScroller': {
      marginTop: '48px !important',
    },
    // '& .MuiDataGrid-columnSeparator': {
    //   minHeight: '34px !important',
    // },
    // '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
    //   borderRight: `1px solid #e9e9e9`,
    // },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    },
    '& .MuiDataGrid-cell': {
      color: 'black',
      fontSize: '12px',
      padding: '16px 10px',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: 'none',
      position: 'absolute',
      bottom: '-70px',
      width: '100%'
    },
    ...customCheckbox(theme),
  }))
  
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton /> */}
        {/* <GridToolbarFilterButton /> */}
        {/* <GridToolbarDensitySelector /> */}
        {/* <GridToolbarExport /> */}
      </GridToolbarContainer>
    )
  }
  
  function CustomPagination() {
    const apiRef = useGridApiContext()
    const page = useGridSelector(apiRef, gridPageSelector)
    const pageCount = useGridSelector(apiRef, gridPageCountSelector)
  
    return (
      <Pagination
        color='primary'
        count={pageCount}
        page={page + 1}
        shape='rounded'
        showFirstButton
        showLastButton
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    )
  }
  
  const StyledGridOverlay = styled('div')(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '& .ant-empty-img-1': {
      fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
      fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
      fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
      fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
      fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
      fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
  }))
  
  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <svg width='120' height='100' viewBox='0 0 184 152' aria-hidden focusable='false'>
          <g fill='none' fillRule='evenodd'>
            <g transform='translate(24 31.67)'>
              <ellipse className='ant-empty-img-5' cx='67.797' cy='106.89' rx='67.797' ry='12.668' />
              <path
                className='ant-empty-img-1'
                d='M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z'
              />
              <path
                className='ant-empty-img-2'
                d='M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'
              />
              <path
                className='ant-empty-img-3'
                d='M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z'
              />
            </g>
            <path
              className='ant-empty-img-3'
              d='M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z'
            />
            <g className='ant-empty-img-4' transform='translate(149.65 15.383)'>
              <ellipse cx='20.654' cy='3.167' rx='2.849' ry='2.815' />
              <path d='M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z' />
            </g>
          </g>
        </svg>
        <Box sx={{mt: 1}}>Không có dữ liệu</Box>
      </StyledGridOverlay>
    )
  }
  
  const TableComponentBancas: React.FC<Props> = ({
    rowData,
    column,
    handleClickRow,
    handleDoubleClickRow,
    pageSize,
    addableRow,
    hidePagination,
    showCheckBox,
    heightTable,
    currentPage,
    loading,
    totalRows,
    handleOnChangePage,
    handleEditRow,
    handleGetSelectedRow,
  }) => {
    const [rows, setRows] = useState<any>([])
    const [page, setPage] = useState(currentPage ? currentPage - 1 : 0)
    const [loadingTable, setLoadingTable] = useState(true)
    const columns: GridColDef[] = column
    const dispatch = useDispatch()
  
    const handleAddRow = () => {
      setRows((prevRows: any) => {
        const newRow = JSON.parse(JSON.stringify(prevRows))
        var obj = {
          id: newRow.length + 1,
        }
        newRow.push(obj)
        return newRow
      })
    }
  
    const handleEdit = (param: GridCellEditCommitParams) => {
      setRows((prevRows: any) => {
        const newRow = JSON.parse(JSON.stringify(prevRows))
        let rowEdited = newRow.find((o: any) => o.id == param.id)
        rowEdited[param.field] = param.value
        return newRow
      })
    }
  
    const handlePageChange = (page: number) => {
      setPage(page)
      if (handleOnChangePage) handleOnChangePage(page + 1)
    }
  
    useEffect(() => {
      if (!loading && rowData) {
        const timeoutId = setTimeout(() => {
          setRows(rowData)
          setLoadingTable(false)
          // if (tableName === '_sellingContractPaymentScheduleDtos') {
          //   let data = {
          //     key: tableName ? tableName : '',
          //     value: rowData,
          //     tab: tabName ? tabName : '',
          //     form: formName ? formName : '',
          //   }
          //   dispatch(form.actions.addProductInfo(data))
          // }
        }, 500)
        return () => {
          clearTimeout(timeoutId)
        }
      }
    }, [rowData, loading])
  
    useEffect(() => {
      if (loading && !loadingTable) {
        setLoadingTable(true)
        setRows([])
      }
    }, [loading, loadingTable])
  
    // useEffect(() => {
    //   if (tableName === '_sellingContractPaymentScheduleDtos' && rowData.length > 0) {
    //     let data = {
    //       key: tableName ? tableName : '',
    //       value: rowData,
    //       tab: tabName ? tabName : '',
    //       form: formName ? formName : '',
    //     }
    //     dispatch(form.actions.addProductInfo(data))
    //   }
    // }, [rowData, tableName])
  
    useEffect(() => {
      if (handleEditRow) handleEditRow(rows)
    }, [rows, handleEditRow])
  
    return (
      <>
        <div style={{height: heightTable ? heightTable : 'calc(100% - 40px)', width: '100%'}}>
          <div style={{display: 'flex', height: '100%'}}>
            <div style={{flexGrow: 1}}>
              {addableRow && (
                <Button className='custom-form-feature-btn' onClick={handleAddRow}>
                  Thêm dòng
                </Button>
              )}
              <StyledDataGrid
                checkboxSelection={showCheckBox}
                paginationMode='server'
                rows={rows}
                columns={columns}
                pagination
                page={page}
                pageSize={pageSize}
                // rowHeight={34}
                rowCount={totalRows ? totalRows : rows.length}
                hideFooterPagination={hidePagination}
                hideFooter={hidePagination}
                rowsPerPageOptions={[pageSize]}
                disableColumnMenu={true}
                components={{
                  Pagination: CustomPagination,
                  Toolbar: CustomToolbar,
                  NoRowsOverlay: CustomNoRowsOverlay,
                }}
                hideFooterSelectedRowCount={true}
                onRowDoubleClick={(param) => handleDoubleClickRow && handleDoubleClickRow(param.row)}
                onRowClick={(param) => handleClickRow(param.row)}
                onCellEditCommit={(param) => handleEdit(param)}
                onPageChange={(page) => handlePageChange(page)}
                loading={loadingTable}
                disableSelectionOnClick
                isRowSelectable={(param: GridRowParams) => param.row.objectInsuredTypeName != 'Đã ký'}
                onSelectionModelChange={(data, details) =>
                  handleGetSelectedRow && handleGetSelectedRow(data)
                }
              />
            </div>
          </div>
        </div>
      </>
    )
  }
  
  export {TableComponentBancas}
  